var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main_content"},[_c('div',{staticClass:"main_img"},[_c('Logo')],1),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_text"},[_c('h1',{staticClass:"main_title"},[_vm._v("Антуриум")]),_vm._v(" "),_c('h2',{staticClass:"main_subtitle"},[_vm._v("Свадебное агентство")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac708fd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/mainpage/MainPage.html
// module id = null
// module chunks = 